import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';

export default {
  name: 'ScheduleSearch',
  props: {
    dates: {
      default: () => [],
      type: Array,
    },
    dateType: {
      default: 'start',
      type: String,
      validator: (val) => ['receive', 'start'].includes(val),
    },
    loading: {
      default: false,
      type: Boolean,
    },
    value: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      openedFilter: false,
      selectedDates: [],
      rangeStart: null,
      type: 'start',
    };
  },
  computed: {
    isSubmitDisabled() {
      return !this.value && !this.selectedDates?.length;
    },
    maxDate() {
      if (this.rangeStart) {
        return dayjs(this.rangeStart).add(6, 'month').toDate();
      }
      return dayjs().add(6, 'month').toDate();
    },
    minDate() {
      if (this.rangeStart) {
        if (dayjs().subtract(2, 'year').isAfter(dayjs(this.rangeStart).subtract(6, 'month'))) {
          return dayjs().subtract(2, 'year').toDate();
        }
        return dayjs(this.rangeStart).subtract(6, 'month').toDate();
      }
      return dayjs().subtract(2, 'year').toDate();
    },
  },
  methods: {
    dateFormatter(arr) {
      return arr.map((time) => this.formatTime(time, 'YYYY/MM/DD')).join(' - ');
    },
    formatTime(time, format = 'YYYY-MM-DD') {
      return dayjs(time).format(format);
    },
    getPeriodWith(period = 'month', date = dayjs()) {
      return {
        end: date.endOf(period),
        start: date.startOf(period),
      };
    },
    onSearch() {
      this.$emit('search');
    },
    onRangeStartClick(start) {
      this.rangeStart = start;
    },
  },
  watch: {
    dates(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.selectedDates = newVal;
        this.rangeStart = newVal[0] || null;
      }
    },
    dateType(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.type = newVal;
      }
    },
    selectedDates(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('updated-dates', newVal);
      }
    },
    type(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('updated-date-type', newVal);
      }
    },
  },
};
